import type { Column } from "@tanstack/react-table";
import type { ReactNode } from "react";
import { LuArrowDown, LuArrowUp, LuArrowUpDown } from "react-icons/lu";

import { Button } from "@/components/ui/button";
import { cn } from "@/utils/lib";

interface RenderSortingHeaderProps<
  T,
> extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<T, unknown>;
  title: string;
  infoTooltip?: ReactNode;
}

export const renderSortingHeader = <T,>({
  column,
  title = "",
  className,
  infoTooltip,
  sortable = true,
}: RenderSortingHeaderProps<T> & {
  sortable?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const isSortedCn = column.getIsSorted();

  if (!sortable) {
    return (
      <div className={cn("flex items-center text-left", className)}>
        <span>{title}</span>
        {infoTooltip && <div className="ml-1 size-4">{infoTooltip}</div>}
      </div>
    );
  }

  return (
    <Button
      variant="ghost"
      onClick={() => column.toggleSorting(!isSortedCn || isSortedCn === "asc")}
      className={cn(
        `
          justify-start px-0 text-left text-muted-foreground
          hover:text-muted
        `,
        className,
      )}
    >
      <span>{title}</span>
      {infoTooltip && <div className="ml-1 size-4">{infoTooltip}</div>}
      {isSortedCn && (
        <>
          {isSortedCn === "asc" ? (
            <LuArrowUp className="ml-2 size-4" />
          ) : (
            <LuArrowDown className="ml-2 size-4" />
          )}
        </>
      )}

      {!isSortedCn && <LuArrowUpDown className="ml-2 size-4" />}
    </Button>
  );
};
